export function createAudioPlayer({ resolveUrl = (src) => src, AudioImpl } = {}) {
  let current = null;
  let settle = null;

  const stop = () => {
    if (current) {
      current.pause();
      current.onended = null;
      current.onerror = null;
      current = null;
    }
    if (settle) {
      const done = settle;
      settle = null;
      done();
    }
  };

  const play = (src) => {
    stop();
    if (!src) return Promise.resolve();
    return new Promise((resolve) => {
      const AudioCtor = AudioImpl || window.Audio;
      const audio = new AudioCtor(resolveUrl(src));
      current = audio;
      settle = resolve;
      const finish = () => {
        if (current === audio) {
          current = null;
          settle = null;
        }
        resolve();
      };
      audio.onended = finish;
      audio.onerror = finish;
      Promise.resolve(audio.play()).catch(finish);
    });
  };

  return { play, stop };
}
